import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const TextInput = ({id, placeholder, title, value, onChange, type}) => {
    const { t } = useTranslation()
    return (
        <div className="mb-3">
            <label htmlFor={id} className="form-label">{t(title)}</label>
            <input type={type} className="form-control" id={id} placeholder={t(placeholder)} value={value} onChange={(e) => onChange(e.target)} />
        </div>
    )
}

TextInput.propTypes = {
    id: PropTypes.string,
    placeholder: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    type: PropTypes.string
}

TextInput.defaultProps = {
    type: 'text'
}

export default TextInput
